/**
 * #625 D9 (/qa #625 L3): "what it covers" for a catalogue discount, worded with THIS school's
 * category names. For the office surfaces that name a discount outside the discounts page (the
 * Families and Students discount pickers, the student view).
 *
 * The category list needs operations_pricing:read (#272): pass the same gate the discount list
 * uses. Until the names have loaded, a discount naming chosen categories returns null rather than
 * flashing "(deleted category)" (the Covers column's rule).
 */
import { useCallback, useMemo } from 'react';
import { useProductCategories } from './useProducts';
import { coverageFromRow, describeCoverage } from '../utils/discountCoverage';

type CoverageRow = Parameters<typeof coverageFromRow>[0];

export function useDiscountCoverageLabel(enabled: boolean): (discount: CoverageRow) => string | null {
  const { data: categories = [], isSuccess } = useProductCategories({ enabled });
  const names = useMemo(() => new Map(categories.map((c) => [c.id, c.name])), [categories]);
  return useCallback(
    (discount: CoverageRow) =>
      isSuccess || discount.coversAllProducts || (discount.coversCategoryIds ?? []).length === 0
        ? describeCoverage(coverageFromRow(discount), names)
        : null,
    [isSuccess, names]
  );
}
